
import { Component, Vue } from "vue-property-decorator";
import { namespace, State } from "vuex-class";
import SOCContactModal from "@/components/SOCContactModal.vue";
import mobileApi from "@/services/api.mobile.service";
const Mobile = namespace("mobile");

@Component({
	components: {
		"soc-contact-modal" : SOCContactModal
	}
})
export default class MobileMenu extends Vue {
	@Mobile.Mutation setMobileMode: (mode: string) => void;
	@State(state => state.User.userPermissions) permissions: {
		[permissionName: string]: number | undefined;
	};

	private showMenu: boolean = false;
	public showSocCallModal: boolean = false;

	private SocTelephoneNumber: string | null = null;

	private get canMobileDispatch() {
		return this.permissions && this.permissions.hasOwnProperty("canMobileDispatch") && this.permissions["canMobileDispatch"];
	}

	private get canManageDispatch() {
		return this.permissions && this.permissions.hasOwnProperty("canManageDispatch") && this.permissions["canManageDispatch"];
	}

	private get canViewCameras() {
		return this.permissions && this.permissions.hasOwnProperty("canViewCameras") && this.permissions["canViewCameras"];
	}

	private get canMobileViews() {
		return this.permissions && this.permissions.hasOwnProperty("canMobileViews") && this.permissions["canMobileViews"];
	}
	
	private get canProcessAlarms() {
		return this.permissions && this.permissions.hasOwnProperty("canProcessAlarms") && this.permissions["canProcessAlarms"];
	}

	private get showSocCallButton(): boolean {
		return (this.SocTelephoneNumber) ? true : false;
	}

	async mounted() {
		// Get the telephone number for the security operations center call button.
        this.SocTelephoneNumber = await mobileApi.getSocTelephone();	// Will only return if the system has mobile/call feature enabled.

		// This sets the order of what is loaded first, if they have permission
		if (this.canMobileDispatch) {
			this.setMobileMode("dispatch");
		} else if (this.canViewCameras) {
			this.setMobileMode("live");
		} else if (this.canMobileViews) {
			this.setMobileMode("views");
		} else if (this.canManageDispatch) {
			this.setMobileMode("manage");
		} else if (this.canProcessAlarms) {
			this.setMobileMode("events");
		}
	}

	public async modeClicked(mode: string) {
		this.setMobileMode(mode);
		this.showMenu = false;
	}
}
